export default "__VITE_ASSET__BErTavMr__"